var React = require('react');

function Edit3 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 20h9","key":0}),React.createElement("path",{"d":"M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z","key":1})]);
}

Edit3.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-pen-line-icon lucide-pen-line"};

module.exports = Edit3;

Edit3.default = Edit3;
